import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget engagement tracking. Never blocks or throws in the UI.
export const track = (type, payload = {}) => {
  try {
    axios.post(`${API}/analytics/event`, { type, ...payload }).catch(() => {/* analytics is best-effort */});
  } catch (e) { /* never let tracking break the UI */ }
};
